import React, { PureComponent, Fragment } from "react";

import ReactEcharts from "echarts-for-react";

export default class PieChart extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      data: this.props.data,
    };
  }

  render() {
    const option = {
      grid: {
        height: this.props.height ? this.props.height : "auto",
      },
      tooltip: {
        trigger: "item",
        formatter: (param) => {
          return param.data
            ? param.data.name +
                " : " +
                param.data.value.toLocaleString() +
                " (" +
                Math.ceil(param.percent) +
                "%)"
            : "";
        },
      },
      legend: {
        orient: "vertical",
        right: "5",
        top: "middle",
        formatter: (name) => {
          let itemValue = this.props.data.find((item) => item.name === name);
          return `${name}: ${itemValue.value.toLocaleString()}`;
        },
      },
      series: {
        type: "pie",
        data: this.props.data,
        radius: "95%",
        animation: false,
        center: ["35%", "50%"],
        labelLine: {
          show: false,
        },
        label: {
          show: false,
          position: "center",
        },
      },
    };

    return (
      <ReactEcharts
        theme="macarons"
        option={option}
        style={{ height: `${this.props.height}px` }}
      />
    );
  }
}
